<script>
import { Bar } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import barOrderService from '../../services/BarOrders/BarOrderService';
import eventBus from '../../eventBus';
export default {
  extends: Bar,
  props: {
    value: {
      type: Object,
      default: {
        startDate: new Date(),
        endDate: new Date(),
        eventId: null,
        machineSerial: '',
        userId: null
      }
    }
  },
  data: function() {
    return {
      chartHourLabel: ["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00","08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
      brandInfo: '',
      brandSuccess: '',
      brandDanger: ''
    }
  },
  created (){    
  },
  watch: {
      'value': function() {
          this.$emit('input', this.value)
      }
  },
  async mounted () {
    this.brandSuccess = getStyle('--success') || '#4dbd74'
    this.brandInfo = '#C3C3C3'
    this.brandDanger = getStyle('--danger') || '#f86c6b'
    await this.fetchData();
    const self = this;
    eventBus.$on(`dashboard-filter:search`, async function() {            
      await self.fetchData();
    });
    
  },
  methods: {    
    formatDecimal(value) {
      return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    async fetchData() {
      const self = this;
      // this.showLoading();      
      let response = await barOrderService.getTpvChart(this.value);
      let result;
      if(response.status == 200) {
        result = response.data;              
        let max = result[result.length];          
        this.renderChart({
          labels: self.chartHourLabel,
          datasets: [
            {
              label: 'TPV por hora',
              backgroundColor: self.brandInfo,
              borderColor: self.brandInfo,
              pointHoverBackgroundColor: '#fff',
              borderWidth: 2,
              data: result
            }
          ]
        }, {
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
              },
              label: function(tooltipItem, data) {
                return self.formatDecimal(tooltipItem.yLabel);
              }
            }
          },
          maintainAspectRatio: false,
          legend: {
            display: true
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                //stepSize: Math.ceil(max / 5),
                max: max,
                callback: function(label, index, labels) {
                  return self.formatDecimal(label);
                }                      
              },
              gridLines: {
                display: true
              },                    
            }]
          }
        })
      }
    }
  }
}
</script>
